// extracted by mini-css-extract-plugin
export default {"content":"_3EAYgDj-","topIcon":"_1jDHZIkA","links":"ITWVv3f9","messenger":"_1-rVyOKk","github":"lqt3xCA3","email":"_1k1vdhG-"};